module.exports = __webpack_public_path__ + "img/Template1.d887b074.jpg";